import { lazy, useMemo } from 'react';
import clsx from 'clsx';
import {
    BlockWrapper,
    ChildrenBlock,
    defineBlock,
    smartProps,
    useEditor,
    useInspectorControl,
} from '@smartfire/js-block-engine';
import style from './style.module.scss';

const Inspector = lazy(() => import('./inspector.js'));

const allowedBlocks = ['core/title', 'core/paragraph', 'smartfire/spacer', 'smartfire/button', 'smartfire/buttons-row'];
const templateBlocks = [
    ['core/heading', { level: 1, placeholder: 'Titre 1' }],
    ['core/heading', { level: 2, placeholder: 'Titre 2' }],
    ['smartfire/buttons-row'],
];

const HomeHeroDesktop = ({ background, contentPosition, showMobile, ...props }) => {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();

    const contentStyle = useMemo(() => {
        const { top, right, bottom, left } = contentPosition;
        let styleObj = {};
        if (parseInt(top) > 0) styleObj['top'] = top;
        if (parseInt(right) > 0) styleObj['right'] = right;
        if (parseInt(bottom) > 0) styleObj['bottom'] = bottom;
        if (parseInt(left) > 0) styleObj['left'] = left;
        return styleObj;
    }, [contentPosition]);

    return (
        <BlockWrapper.Section
            className={clsx(
                style.block,
                isEditing ? style.admin : style.frontend,
                background && style.background,
                props.className,
            )}
            style={{ backgroundImage: background ? 'url(' + background.url + ')' : null }}
        >
            <ChildrenBlock
                className={style.content}
                style={contentStyle}
                gutenbergEditorConfig={{
                    orientation: 'vertical',
                    allowedBlocks: allowedBlocks,
                    template: templateBlocks,
                    templateLock: false,
                }}
            />
        </BlockWrapper.Section>
    );
};

export default defineBlock({
    Block: HomeHeroDesktop,
    smartProps: {
        background: smartProps.image,
        contentPosition: smartProps.object.withDefault({
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
        }),
    },
    setup: {
        title: 'Home Hero',
    },
});
